export function mergeBuffers(lhs: Int16Array, rhs: Int16Array) {
  const merged = new Int16Array(lhs.length + rhs.length)
  merged.set(lhs, 0)
  merged.set(rhs, lhs.length)
  return merged
}
